import { render, staticRenderFns } from "./CustomerRelations.vue?vue&type=template&id=47b68fd6&"
import script from "./CustomerRelations.vue?vue&type=script&lang=js&"
export * from "./CustomerRelations.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRelations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b68fd6')) {
      api.createRecord('47b68fd6', component.options)
    } else {
      api.reload('47b68fd6', component.options)
    }
    module.hot.accept("./CustomerRelations.vue?vue&type=template&id=47b68fd6&", function () {
      api.rerender('47b68fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/CustomerRelations.vue"
export default component.exports